import { Modal, Select, Form, Button, Col, Row } from 'antd';
import { selectFormatDate, setFormatDatetime } from 'app/commonRedux/appSlice';
import { useAppSelector } from 'app/hooks';
import { notificationToast } from 'components/notificationToast';
import { Notification } from 'constants/notification';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const { Option } = Select;

const optionDateFormat: any = [
  { date: 'DD-MM-YYYY', month: 'MM-YYYY' },
  { date: 'YYYY-MM-DD', month: 'YYYY-MM' },
  { date: 'MM-DD-YYYY', month: 'MM-YYYY' },
  { date: 'DD/MM/YYYY', month: 'MM/YYYY' },
  { date: 'YYYY/MM/DD', month: 'YYYY/MM' },
  { date: 'MM/DD/YYYY', month: 'MM/YYYY' },
];

const ModalConfigDateTime = (props: any) => {
  const { visible, setVisible } = props;
  const [form] = Form.useForm();
  const dateFormat = useAppSelector(selectFormatDate);
  const { t } = useTranslation(['configuration', 'action', 'common']);
  const [, setSelectedFormatDate] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (dateFormat) {
      form.setFieldsValue({
        dateFormat: dateFormat,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFormat]);

  const handleOnChangeFormatDate = (value: any) => {
    setSelectedFormatDate(value);
  };

  const onFinish = (value: any) => {
    try {
      const temp = optionDateFormat.filter((item: any) => {
        return item.date === value.dateFormat;
      });

      dispatch(
        setFormatDatetime({
          formatDate: value.dateFormat,
          formatMonth: temp[0].month,
          formatDatetime: `${value.dateFormat} - HH:mm`,
        }),
      );
      notificationToast(
        Notification.Type.Success,
        t('common:update_success'),
        Notification.Duration._3s,
      );
      setVisible(false);
    } catch (error: any) {
      notificationToast(Notification.Type.Error, error.message, Notification.Duration._3s);
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={() => {
        setVisible(false);
      }}
      footer={null}
    >
      <Form form={form} onFinish={onFinish}>
        <Form.Item name="dateFormat" label={t('setupDateTimeFormat.date_format')}>
          <Select
            style={{ width: 200 }}
            defaultValue={dateFormat}
            onChange={handleOnChangeFormatDate}
          >
            {optionDateFormat.map((item: any, key: number) => {
              return (
                <Option value={item.date} key={key}>
                  {item.date}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item noStyle>
          <Row>
            <Col
              span={24}
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                {t('action:save')}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalConfigDateTime;
